<script lang="ts" setup>
import type { popoverProps, PopoverProps, } from "element-plus"
import type { Slots, } from "vue"
import { isArray, } from "lodash-es"
import { Comment, Fragment, isVNode, } from "vue"
import { useTemplate, } from "@/hooks/useTemplate.ts"

defineOptions({
  name: "CollapseGroup",
},)

const props = withDefaults(defineProps<{
  limit?: number
  direction?: "horizontal" | "vertical"
  popoverProps?: Partial<PopoverProps>
  containerClass?: string
  visibleClass?: string
  collapseClass?: string
}>(), {
  limit: 2,
  direction: "vertical",
},)

const isHorizontal = computed(() => props.direction === "horizontal",)

const { default: defaultSlot, } = useSlots() as Slots

// 递归处理Fragment，获取所有为vnode的子节点
function flatFragment(children: VNode[],) {
  const flatChildren: VNode[] = []
  for (const child of children) {
    if (child.type === Fragment && isArray(child.children,)) {
      flatChildren.push(...flatFragment(child.children.filter(vnode => isVNode(vnode,),),),)
    } else {
      flatChildren.push(child,)
    }
  }
  return flatChildren
}

const vnodes = computed(() => {
  return flatFragment((defaultSlot?.() || []).filter(vnode => vnode.type !== Comment,),)
},)

const visibleVNodes = computed(() => {
  return vnodes.value.filter((_, index,) => index < props.limit,)
},)

const collapseVNodes = computed(() => {
  return vnodes.value.filter((_, index,) => index >= props.limit,)
},)

const { DefineTemplate, UseTemplate, } = useTemplate()
</script>

<template>
  <DefineTemplate>
    <ElPopover v-bind="popoverProps">
      <template #reference>
        <slot name="reference">
          <Icon class="ml-2" icon="ep:arrow-down" />
        </slot>
      </template>
      <div class="flex flex-col">
        <template v-for="(item, index) in collapseVNodes" :key="index">
          <component :is="item" :class="[`collapse-group-item__${props.direction}`, props.collapseClass]" />
        </template>
      </div>
    </ElPopover>
  </DefineTemplate>
  <div :class="$attrs.class" class="collapse-group">
    <div :class="[isHorizontal ? 'flex-row items-center' : 'flex-col items-start', props.containerClass]" class="flex">
      <template v-for="(item, index) in visibleVNodes" :key="index">
        <component :is="item" :class="[`collapse-group-item__${props.direction}`, props.visibleClass]" />
      </template>
      <template v-if="collapseVNodes.length">
        <UseTemplate v-if="isHorizontal" />
      </template>
    </div>
    <div v-if="!isHorizontal && collapseVNodes.length" class="flex items-center">
      <UseTemplate />
    </div>
  </div>
</template>

<style lang="scss">
@use "@/styles/variables.module.scss" as *;

.collapse-group {
  display: flex;
  align-items: center;

  &-item__vertical {
    &.#{$elNamespace}-button + .#{$elNamespace}-button {
      margin-left: 0;
      margin-right: 0;
    }
  }
}
</style>
